import {
    CrudService,
    UserService,
    AuthService,
    AzureService,
    AzureGraphService,
} from './services';
import { WallofFameService } from './services/walloffame';
import { DiscoverPortalService } from './services/discoverPortal';
import { RoleService } from './services/role';
import { WhatsNewService } from './services/whatsnew';
import { EntertainmentDailyService } from './services/entertainmentdaily';
import { WallofFameTypeService } from './services/walloftype';
import { PoliciesService } from './services/policies';
import { PolicyTypeService } from './services/policytype';
import { PoliciesSiteAccessService } from './services/policiessiteaccess';
import { ZohoService } from './services/zoho';
import { WhatsNewSiteAccessService } from './services/whatsnewsiteaccess';
import { AssociateDetailsService } from './services/associatedetails';
import { ItHubService } from './services/itHub';
import { FlashNewsService } from './services/flashNews';
import { InsightsService } from './services/insights';
import { LearningLoungeService } from './services/learningLounge';
import { ClientsInformationService } from './services/clientsinformation';
import { DepartmentService } from './services/departments';
import { PollService } from './services/poll';
import { DocumentDetailService } from './services/documentdetails';
import { SolutionsService } from './services/solutions';
import { SolutionRecommendedService } from './services/solutionrecommended';
import { MarketingBrochuresService } from './services/marketingbrochures';
import { MarketingEventsService } from './services/marketingevents';
import { MarketingVideosService } from './services/marketingvideos';
import { IndustryNewsService } from './services/industrynews';
import { ThoughtLeadershipService } from './services/thoughtleadership';
import { PodcastsService } from './services/podcasts';
import { SolutionAuthorsService } from './services/solutionauthors';
import { MarketingAwardsService } from './services/marketingawards';
import { SkillsService } from './services/skills';
import { RoleMenuService } from './services/rolemenuaccess';
import { MarketingInsightsService } from './services/marketinginsights';
import { HubSpocService } from './services/hubspoc';
import { SearchMarketingHubService } from './services/searchmarketinghub';
import { SearchFlipHubService } from './services/searchfliphub';
import { HubsService } from './services/hubs';
import { GalleryService } from './services/homegallery';
import { EmployeeSpotlightService } from './services/employeespotlight';
import { AnnouncementsService } from './services/announcements';
import { ChatbotService } from './services/chatBot'
import { PeopleHubGalleryService } from './services/peoplehubgallery';
import { ConnectVideosService } from './services/connectvideos';
import { ActiveEmployeeService } from './services/activeemployees';
import { BenchEmployeeService } from './services/benchemployees';
import { CertificationService } from './services/certification';
import { EmployeeSkillsService } from './services/employeeskills';
import { EmployeesBillabilityService } from './services/employeesBillability';
import { CustomerService } from './services/customer';
import { InsuranceProvisionCoverageService } from './services/insuranceprovisioncoverage';
import { NameontheAgilisiumEntityService } from './services/nameontheagilisiumentity';
import { TypeofContractService } from './services/typeofcontract';
import { VendorsService } from './services/vendors';
import { SharePointService } from './services/sharepoint';
import { FlipHubEpisodesService } from './services/manageflipevents';
import {UserRoleAssignmentsService} from './services/userroleassignments';
import { PracticeService } from './services/practice';
import { EmployeeSeatService } from './services/employeeseats';
import { DataverseService } from './services/dataverse';
import { FutureFlexService } from './services/futureflex';
export default class EdsApiClient {
    crud;
    user;
    auth;
    azure;
    azureGraphApi;
    store = {
        apiDomain: '',
        token: undefined,
    };

    constructor(apiDomain) {
        this.store.apiDomain = apiDomain;
        this.crud = new CrudService(this.store);
        this.user = new UserService(this.store);
        this.auth = new AuthService(this.store);
        this.rolelist = new RoleService(this.store);
        this.azure = new AzureService(this.store);
        this.azureGraphApi = new AzureGraphService();
        this.walloffame = new WallofFameService(this.store);
        this.discoverportal = new DiscoverPortalService(this.store);
        this.whatsnew = new WhatsNewService(this.store);
        this.insights = new InsightsService(this.store);
        this.entertainmentdaily = new EntertainmentDailyService(this.store);

        this.policiesservice = new PoliciesService(this.store);
        this.PolicyTypeService = new PolicyTypeService(this.store);
        this.policiessiteaccessservice = new PoliciesSiteAccessService(this.store);
        this.WallofFameTypeService = new WallofFameTypeService(this.store);
        this.ZohoService = new ZohoService(this.store);
        this.WhatsNewSiteAccessService = new WhatsNewSiteAccessService(this.store);
        this.associatedetails = new AssociateDetailsService(this.store);
        this.skills = new SkillsService(this.store);
        this.itHub = new ItHubService(this.store);
        this.flashNews = new FlashNewsService(this.store);
        this.learningLounge = new LearningLoungeService(this.store);
        this.clientsinformation = new ClientsInformationService(this.store);
        this.departments = new DepartmentService(this.store);
        this.poll = new PollService(this.store);
        this.documentDetails = new DocumentDetailService(this.store);
        this.solutions = new SolutionsService(this.store);
        this.solutionrecommended = new SolutionRecommendedService(this.store)
        this.marketingbrochures = new MarketingBrochuresService(this.store);
        this.marketingevents = new MarketingEventsService(this.store);
        this.marketingvideos = new MarketingVideosService(this.store);
        this.industrynews = new IndustryNewsService(this.store);
        this.thoughtleadership = new ThoughtLeadershipService(this.store);
        this.podcasts = new PodcastsService(this.store);
        this.solutionauthors = new SolutionAuthorsService(this.store);
        this.marketingawards = new MarketingAwardsService(this.store);
        this.rolemenu = new RoleMenuService(this.store);
        this.insight = new MarketingInsightsService(this.store);


        this.hubspoc = new HubSpocService(this.store);
        this.searchmarketinghub = new SearchMarketingHubService(this.store);
        this.searchfliphub = new SearchFlipHubService(this.store);
        this.hubs = new HubsService(this.store);
        this.homegallery = new GalleryService(this.store);
        this.employeespotlight = new EmployeeSpotlightService(this.store);
        this.announcements = new AnnouncementsService(this.store);
        this.chatbot = new ChatbotService(this.store)
        this.peoplehubgallery = new PeopleHubGalleryService(this.store);
        this.connectvideos = new ConnectVideosService(this.store);
        this.activeemployees = new ActiveEmployeeService(this.store);
        this.benchemployees = new BenchEmployeeService(this.store)
        this.certification = new CertificationService(this.store);
        this.employeeskills = new EmployeeSkillsService(this.store);
        this.employeesBillability = new EmployeesBillabilityService(this.store);
        this.customer = new CustomerService(this.store);
        this.insuranceprovisioncoverage = new InsuranceProvisionCoverageService(this.store);
        this.nameontheagilisiumentity = new NameontheAgilisiumEntityService(this.store);
        this.typeofcontract = new TypeofContractService(this.store);
        this.vendors = new VendorsService(this.store);
        this.sharepoint = new SharePointService(this.store);
        this.fliphubepisodes = new FlipHubEpisodesService(this.store);
        this.userroleassignments = new UserRoleAssignmentsService(this.store);
        this.practice = new PracticeService(this.store);
        this.dataverse = new DataverseService(this.store);
        this.seats = new EmployeeSeatService(this.store);
        this.futureflex = new FutureFlexService(this.store);
    }

    setToken(token) {
        this.store.token = token;
    }
}
